import React from 'react';

function ClickMark({color = '#222220', className = '', style}) {
  return (
    <svg
      className={`click-mark ${className}`}
      style={style}
      viewBox="0 0 100 100"
      fill={color}
      stroke={color}
      aria-hidden="true"
    >
      <path d="M38 38 L88 58 Q93 61 88 65 L68 74 L59 94 Q56 99 52 94 Z" strokeWidth="6" strokeLinejoin="round" />
      <g strokeWidth="7" strokeLinecap="round" fill="none">
        <path d="M14 30 L24 36" />
        <path d="M30 10 L34 20" />
        <path d="M54 14 L52 24" />
      </g>
    </svg>
  );
}

export default ClickMark;